<template>
  <div class="activity-config-container">
    <el-card>
      <header class="activity-config-container__header">活动配置管理</header>
      <el-tabs v-model="activeTab" type="border-card">
        <el-tab-pane label="活动模板配置" name="model">
          <ModelConfig />
        </el-tab-pane>
        <el-tab-pane label="活动组件化配置" name="unit">
          <UnitConfig />
        </el-tab-pane>
        <el-tab-pane label="奖励key配置" name="rewardKey">
          <RewardKeyConfig />
        </el-tab-pane>
        <el-tab-pane label="奖励id参考表" name="rewardTable">
          <RewardTable />
        </el-tab-pane>
        <!-- 后续可以在这里添加其他活动配置类型 -->
      </el-tabs>
    </el-card>
  </div>
</template>

<script>
import ModelConfig from './ModelConfig.vue'
import UnitConfig from './UnitConfig.vue'
import RewardKeyConfig from '../../../components/rewardConfig/reward-key-config.vue'
import RewardTable from '../../../components/rewardConfig/config-table.vue'

export default {
  name: 'ActivityConfigContainer',
  components: {
    ModelConfig,
    UnitConfig,
    RewardKeyConfig,
    RewardTable
  },
  data() {
    return {
      activeTab: 'model'
    }
  }
}
</script>

<style scoped lang="scss">
.activity-config-container {
  .el-card {
    // 移除固定高度限制，让内容可以自然滚动
    // height: calc(100vh - 56px);
  }

  &__header {
    font-size: 22px;
    font-weight: bold;
    margin-bottom: 16px;
  }

  .el-tabs {
    // 移除固定高度限制，让标签页内容可以自然滚动
    // height: calc(100vh - 120px);
    
    // ::v-deep .el-tab-pane {
    //   height: 100%;
    // }
    
    // ::v-deep .el-tabs__content {
    //   height: calc(100% - 40px);
    // }
  }
}
</style> 